// this page design needs to be done
const ErrorComponent = () => {
  return <div>{"Error with Status Code"}</div>;
};

export default ErrorComponent;
